// import styled from "@emotion/styled";
import styled from "@emotion/styled/macro";
import { FaMagento } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Container } from "../InfoSection/InfoSection.elements";
// import styled from 'styled-components';

export const Nav = styled.nav`
    background: #101522;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    position: sticky;
    top: 0;
    z-index: 999;

    @media screen and (max-width: 960px) {
        height: 90px;
    }
`

export const NavbarContainer = styled(Container)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    position: relative;

    ${Container}

    @media screen and (max-width: 960px) {
        height: 70px;
        padding: 0 15px;
        flex-wrap: nowrap;
    }
`
export const NavLogo = styled(Link)`
    color: #fff;
    justify-self: flex-start;
    cursor: pointer;
    text-decoration: none;
    font-size: 2rem;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    z-index: 1000;
    padding-left: 20px;

    img {
        width: 120px;
        height: 120px;
        object-fit: contain;
    }

    @media screen and (max-width: 960px) {
        font-size: 1.5rem;
        padding-left: 15px;
        
        img {
            width: 90px;
            height: 90px;
        }
    }

    @media screen and (max-width: 480px) {
        font-size: 1.2rem;
        padding-left: 2px;
        
        img {
            width: 95px;
            height: 95px;
        }
    }
`


export const NavIcon = styled(FaMagento)`
    margin-right: 0.5rem;

`

export const HamburgerIcon = styled.div`
    display: none;

    @media screen and (max-width: 960px) {
        display: block;
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        font-size: 1.8rem;
        cursor: pointer;
        z-index: 1000;
        color: #fff;
    }
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin: 0;
    padding: 0;
  
    @media screen and (max-width: 960px) {
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: calc(100vh - 70px);
        position: fixed;
        top: 70px;
        opacity: 1;
        transition: left 0.3s ease-in-out;
        background-color: #101522;
        left: ${({ click }) => (click ? '0' : '-100%')};
        overflow-y: auto;
        z-index: 998;
        padding-top: 20px;
    }
`

export const NavItem = styled.li`
    border-bottom: 2px solid transparent;
    border-radius: 2px;

    &:hover {
        border-bottom: 4px solid #101522;
    }

    @media screen and (max-width: 960px) {
        width: 100%;
        padding: 15px 20px;

        &:hover {
            border-bottom: none;
            background-color: rgba(255, 255, 255, 0.1);
        }
    }
`

export const NavLinks = styled(Link)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0.5rem 1rem;
    height: 100%;
    
    @media screen and (max-width: 960px) {
        text-align: center;
        padding: 1rem;
        width: 100%;
        display: table;
        font-size: 1.2rem;

        &:hover {
            color: #4b59f7;
            transition: all 0.3s ease;
        }
    }
`

export const NavItemBtn = styled.li`
  @media screen and (max-width: 960px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
  }
`;

export const NavHeader = styled.h1`
    font-size: 20px;
    margin: 0;
    padding: 10px;
    white-space: nowrap;

    @media screen and (max-width: 1200px) {
        font-size: 18px;
    }

    @media screen and (max-width: 960px) {
        font-size: 16px;
        display: none;
    }

    @media screen and (max-width: 480px) {
        font-size: 14px;
        display: none;
    }

    @media screen and (max-width: 380px) {
        display: none;
    }
`;


export const NavBtnLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding: 8px 16px;
  height: 100%;
  width: 100%;
  border: none;
  outline: none;
`;

export const Button = styled.button`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? '#4B59F7' : '#0467FB')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    transition: all 0.3s ease-out;
    background: #fff;
    background-color: ${({ primary }) => (primary ? '#0467FB' : '#4B59F7')};
  }
  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;






export const SearchContainer = styled.div`
    position: relative;
    flex: 1;
    max-width: 400px;
    margin: 0 auto;
    padding: 0 20px;

    @media screen and (max-width: 960px) {
        position: absolute;
        left: 130px;  /* Start after logo */
        top: 50%;
        transform: translateY(-50%);
        width: calc(100% - 210px);  /* Expand to fill space minus logo and hamburger */
        max-width: none;
        padding: 0;
        z-index: 999;
    }

    @media screen and (max-width: 480px) {
        left: 110px;  /* Closer to logo on small screens */
        width: calc(100% - 175px);  /* More space */
    }
`;
export const SearchInput = styled.input`
    width: 100%;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 10px;
    font-size: 14px;
    outline: none;

    @media screen and (max-width: 960px) {
        padding: 12px;
        font-size: 13px;
    }
`;

export const SearchButton = styled.button`
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media screen and (max-width: 960px) {
        right: 10px;
        width: 28px;
        height: 28px;
    }
`;

export const SearchDropdown = styled.div`
    position: absolute;
    top: 110%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 400px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    list-style: none;
    margin: 0;
    padding: 0;
    z-index: 1000;
    overflow: hidden;
    max-height: 400px;
    overflow-y: auto;

    @media screen and (max-width: 960px) {
        max-width: 100%;
        max-height: 300px;
    }
`;
// export const DropdownItem = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 10px 15px;
//   cursor: pointer;
//   border-bottom: 1px solid #eee;
//   &:hover {
//     background-color: #f5f5f5;
//   }
// `;

export const ProductImage = styled.img`
  width: 45px;
  height: 45px;
  object-fit: contain;
  margin-right: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

export const ProductName = styled.div`
  font-weight: 500;
  color: #333;
  font-size: 1rem;
`;

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ProductPrice = styled.div`
  font-size: 0.9rem;
  color: #007bff;
`;

export const AllResultsButton = styled.div`
    background-color: #007bff;
    color: white;
    text-align: center;
    padding: 12px;
    cursor: pointer;
    border-radius: 0 0 8px 8px;
    transition: background-color 0.2s;
    
    &:hover {
        background-color: #0056b3;
    }

    @media screen and (max-width: 960px) {
        padding: 10px;
        font-size: 14px;
    }
`;
// Profile Image
export const Avatar = styled.img`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 8px;
    object-fit: cover;
    border: 2px solid #fff;

    @media screen and (max-width: 960px) {
        width: 40px;
        height: 40px;
    }
`;

// DropdownWrapper.js
export const DropdownWrapper = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background-color: #fff;
    color: #000;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    z-index: 9999;
    min-width: 180px;
    transition: all 0.3s ease;

    @media screen and (max-width: 960px) {
        position: relative;
        top: 0;
        right: 0;
        width: 100%;
        box-shadow: none;
        border-radius: 0;
        margin-top: 10px;
    }
`;

// DropdownItem.js
export const DropdownItem = styled.div`
    padding: 10px 15px;
    cursor: pointer;
    border-top: 1px solid #eee;
    color: ${({ danger }) => (danger ? '#d00' : '#000')};

    &:hover {
        background-color: #f5f5f5;
    }

    @media screen and (max-width: 960px) {
        padding: 12px 20px;
        font-size: 15px;
    }
`;